<template>
  <div class="info fz-sm" v-if="author || date" data-comp="a-author-date">
    <p class="info__author" v-if="author">{{ author }}</p>
    <p class="info__date" v-if="date">
      <a-date :date="date"></a-date>
    </p>
  </div>
</template>

<script setup>
defineProps({
  author: {
    type: String,
    default: ""
  },
  date: {
    type: String,
    default: ""
  }
});
</script>

<style lang="scss" scoped>
.info {
  display: flex;
  flex-direction: row;
  margin-top: pxToRem(18);

  &__author {
    padding-right: pxToRem(10);
    margin-right: pxToRem(10);
    position: relative;

    &:after {
      content: "";
      position: absolute;
      top: 50%;
      right: 0;
      transform: translateY(-50%);
      height: pxToRem(14);
      width: 1px;
      background-color: var(--color-txt-primary);
    }
  }
}
</style>
